import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const ButtonContainer = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
    gap: 8px;
`;

const disabledStyle = ({ $isSelected }: { $isSelected: boolean }) => css`
  background-color: ${$isSelected ? '#fbd1d9' : '#FFFFFF'};
  background-image: none;
  pointer-events: none;
  color: #333333
`;

const ChoiceButton = styled.button<{ $isSelected: boolean, isDisabled?: boolean }>`
  flex: 1;
  padding: 8px 0px;
  font-size: 0.8rem;
  background-color: ${props => (props.$isSelected ? '#3B56A6' : '#FFFFFF')};
  background-image: ${props => props.$isSelected ? 'linear-gradient(to right, #3B56A6, #2081C4)' : 'none'};
  color: ${props => (props.$isSelected ? '#ffffff' : '#333333')};
  border: 2px solid #58585A;
  border-radius: 30px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s, background-image 0.3s;

  ${({ isDisabled, $isSelected }) => isDisabled && disabledStyle({ $isSelected })}
`;

interface Props {
  option1: string;
  option2: string;
  defaultOption?: string; //TODO: refactor this into 'selectedOption' and remove defaultOption
  onSelectionChange?: (selectedOption: string) => void;
  disabled?: boolean;
}

const DualChoiceButtons: React.FC<Props> = ({ option1, option2, defaultOption, onSelectionChange, disabled }) => {
  const [selectedOption, setSelectedOption] = useState<string>(defaultOption || option1);

  const handleButtonClick = (option: string) => {
    setSelectedOption(option);
    if (onSelectionChange) {
      onSelectionChange(option);
    }
  };

  return (
    <>
      <ButtonContainer>
        <ChoiceButton $isSelected={selectedOption === option1} onClick={() => handleButtonClick(option1)} isDisabled={disabled}>
          {option1}
        </ChoiceButton>
        <ChoiceButton $isSelected={selectedOption === option2} onClick={() => handleButtonClick(option2)} isDisabled={disabled}>
          {option2}
        </ChoiceButton>
      </ButtonContainer>
    </>
  );
};

export default DualChoiceButtons;
